import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ResultContextData {
  isModalOpen: boolean;
  modalContent: React.ReactNode;
  openModal: (content: React.ReactNode) => void;
  closeModal: () => void;
}

const ResultContext = createContext<ResultContextData>({} as ResultContextData);

interface ResultProviderProps {
  children: ReactNode;
}

export const ResultProvider: React.FC<ResultProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState<React.ReactNode>(null);

  const openModal = (content: React.ReactNode) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <ResultContext.Provider
      value={{
        isModalOpen,
        modalContent,
        openModal,
        closeModal
      }}
    >
      {children}
    </ResultContext.Provider>
  );
};

export const useResult = (): ResultContextData => {
  const context = useContext(ResultContext);

  if (!context) {
    throw new Error('useResult must be used within a ResultProvider');
  }

  return context;
}; 